import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

// Match strength is the signal matcher's 1-5 score of how strong a match the
// record is (`signals.rating`): 1-2 no match, 3 solid, 4 strong, 5
// high-conviction. Not to be confused with the research agent's confidence,
// which says how sure it is of its verdict (see VerdictCondition).
export const MATCH_STRENGTH_SCALE =
  "The signal matcher's 1–5 score of how strong a match the record is: 3 solid, 4 strong, 5 high-conviction.";

// matched=true implies strength >= 3, so "Any match" maps to no threshold.
export const MATCH_STRENGTH_OPTIONS: { value: number | null; label: string }[] = [
  { value: null, label: "Any match" },
  { value: 3, label: "≥ 3 (solid)" },
  { value: 4, label: "≥ 4 (strong)" },
  { value: 5, label: "5 (high-conviction)" },
];

/** Minimum match strength a root workflow step fires at. */
export default function MatchStrengthSelect({
  value,
  onChange,
  helperText,
  disabled,
}: {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  helperText?: string;
  disabled?: boolean;
}) {
  return (
    <TextField
      label="Match strength"
      select
      size="small"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
      helperText={helperText}
      disabled={disabled}
      fullWidth
    >
      {MATCH_STRENGTH_OPTIONS.map((opt) => (
        <MenuItem key={opt.label} value={opt.value === null ? "" : opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
